import { useCallback, useEffect, useState } from 'react';

export function useSimulatedLoad(delay = 450) {
  const [loading, setLoading] = useState(true);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    const timer = window.setTimeout(() => {
      if (active) setLoading(false);
    }, delay);
    return () => {
      active = false;
      window.clearTimeout(timer);
    };
  }, [delay, tick]);

  const retry = useCallback(() => setTick((t) => t + 1), []);

  return { loading, retry };
}